module.exports = __webpack_public_path__ + "static/img/legend_xg_dark.7a3aa5a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/legend_xg_dark.png
// module id = zxGK
// module chunks = 94